import { render, staticRenderFns } from "./level1-tabs.vue?vue&type=template&id=17cd99c0&"
import script from "./level1-tabs.vue?vue&type=script&lang=js&"
export * from "./level1-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports